import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const priceSlice = createSlice({
  name: "price",
  initialState: {
    loading: false,
    list: [],
    priceData: {},
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    getPriceData:(state,action)=>{
      state.priceData = action.payload;
    }
  }
});

export const {loading,getPriceData} = priceSlice.actions;

export const getPrice = () =>
  async (dispatch) => {
    try {
      dispatch(loading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_price`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(getPriceData(data));
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      errorHandling(error);
    }
  };

export const updatePackageList = (formData) =>
    async (dispatch) => {
      try {
        dispatch(loading(true));
        const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_price`;
        const { data } = await axios.post(url, formData , {
          headers: {
            Authorization: localStorage.getItem('token')
          }
        });
        dispatch(getPriceData(data));
        dispatch(loading(false));
      } catch (error) {
        dispatch(loading(false));
        errorHandling(error);
      }
    };

export default priceSlice.reducer;